export enum ID_TYPE_APPLICANT {
  Privato = '1',
  Pubblico = '2',
}
